import { Component, OnInit, Input } from "@angular/core";
import { SummaryDetails } from "../../../plan/_components/summary/summary-details.model";
import { SummaryFigureContext, SummaryFigureValueType } from "../../../plan/_components/summary/summary-figure.model";

@Component({
    selector: "summary-details-header",
    templateUrl: "./summary-details-header.component.html",
    styleUrls: ["./summary-details-header.component.scss"],
    standalone: false
})
export class SummaryDetailsHeaderComponent implements OnInit {
	private __summary: SummaryDetails;

	@Input() set summary(val: SummaryDetails) {
		console.log("header summary : ", val);
		this.__summary = val;
		if (this.__summary) {
			this.__updateFooterFigures();
		} else {
			this.__reset();
		}
	}

	_serviceName: string;
	_serviceSubText: string;
	_isFooter: boolean;
	_planHeaderDesktopName?: string;
	_planHeaderIcon?: string;
	_planHeaderSmallDeviceName?: string;
	_monthlyCost: SummaryFigureContext;
	_dueTodayCost: SummaryFigureContext;
	_discount: SummaryFigureContext;
	_annualSavings: SummaryFigureContext;
	_promoDiscountValue: SummaryFigureContext;

	constructor() {}

	ngOnInit() {}

	public get isMobileOnly(): boolean {
		return (
			this._serviceName.toLowerCase() === "mobile" ||
			this._serviceSubText.toLowerCase() === "mobile"
		);
	}

	private __reset() {
		this._serviceName = "";
		this._serviceSubText = "";
		this._planHeaderDesktopName = "";
		this._planHeaderIcon = "";
		this._planHeaderSmallDeviceName = "";
		this._monthlyCost = undefined;
		this._dueTodayCost = undefined;
		this._discount = undefined;
		this._annualSavings = undefined;
		this._promoDiscountValue = undefined;
	}

	private __updateFooterFigures() {
		this._serviceName = this.__summary.serviceName;
		this._planHeaderDesktopName = this.__summary.planHeaderDesktopName;
		this._planHeaderIcon = this.__summary.planHeaderIcon;
		this._planHeaderSmallDeviceName = this.__summary.planHeaderSmallDeviceName;
		this._serviceSubText = this.__summary.serviceSubText;
		this._isFooter = this.__summary.isFooter;

		this._monthlyCost = <SummaryFigureContext>{
			value: this.__summary.monthlyCost ? this.__summary.monthlyCost : 0,
			subText: this.__summary.monthlyCostFooterText
				? this.__summary.monthlyCostFooterText
				: "/mth",
			discountText: this.__summary.promoDiscountDurationFooterText
				? this.__summary.promoDiscountDurationFooterText
				: ""
		};

		if (
			this.__summary.promoDiscountValue !== undefined ||
			this.__summary.promoDiscountValue !== null
		) {
			this._promoDiscountValue = <SummaryFigureContext>{
				value:
					this.__summary.monthlyCost -
					this.__summary.promoDiscountValue,
				subText: ""
			};
		}
		if (this.__summary.dueTodayCost) {
			this._dueTodayCost = <SummaryFigureContext>{
				value: this.__summary.dueTodayCost,
				subText: "Due Today"
			};
		} else {
			this._dueTodayCost = undefined;
		}

		if (this.__summary.discount) {
			this._discount = <SummaryFigureContext>{
				value: this.__summary.discount.amount,
				valueType: this.__valueType,
				valueSuffix: "off",
				subText: `${this.__summary.serviceName} Service`
			};

			this._annualSavings = <SummaryFigureContext>{
				value: this.__yearlyDiscount,
				subText: "Annual savings"
			};
		} else {
			this._discount = undefined;
			this._annualSavings = undefined;
		}
	}

	private get __yearlyDiscount(): number {
		if (this.__summary.discount.type === "dollar") {
			return this.__yearlyDiscountFromDollar();
		} else if (this.__summary.discount.type === "percent") {
			return this.__yearlyDiscountFromPercent();
		} else {
			return 0;
		}
	}

	private __yearlyDiscountFromDollar(): number {
		return this.__summary.discount.amount * this.__discountTerm;
	}

	private __yearlyDiscountFromPercent() {
		const discountValue =
			(this.__summary.discount.amount / 100) * this.__summary.monthlyCost;
		return discountValue * this.__discountTerm;
	}

	private get __discountTerm(): number {
		switch (this.__summary.discount.term) {
			case "full-term":
				return 12;
			case "once":
				return 1;
			default:
				return <number>this.__summary.discount.term;
		}
	}

	private get __valueType(): SummaryFigureValueType {
		switch (this.__summary.discount.type) {
			case "percent":
				return "percent";
			case "dollar":
				return "currency";
			default:
				return undefined;
		}
	}
}
